'use strict';

module.exports = function isSamsungBrowser(ua) {
  ua = ua || global.navigator.userAgent;
  return /SamsungBrowser/i.test(ua);
};



//////////////////
// WEBPACK FOOTER
// ./node_modules/@braintree/browser-detection/is-samsung.js
// module id = 207
// module chunks = 0